import { removeBrowserCookie } from '@edu-frontend/modules/src/shared/lib/cookies';
import Cookies from 'js-cookie';

/** Берем из кук последний teamId, чтобы использовать его во вьюхах и клиенте */
export const getSavedTeamId = () => Cookies.get('lab_team_id');

export const clearSavedTeamId = () => removeBrowserCookie('lab_team_id');
